import daltonize from "color_vision_daltonize"

function daltonizeImages(images) {
  if (window.gon.colorBlindness === "normal") return

  for (const image of images) {
    daltonizeImage(image, (newUrl) => {
      image.src = newUrl
    })
  }
}

export function daltonizeImage(image) {
  if (window.gon.colorBlindness === "normal") return Promise.resolve()

  return new Promise((resolve) => {
    const imageUrl = image?.src || image
    const img = document.createElement("img")
    img.crossOrigin = "Anonymous"
    img.onload = function() {
      daltonize(this, {
        type: window.gon.colorBlindness,
        callback: (canvas) => {
          const url = canvas.toDataURL()
          resolve(url, imageUrl)
        }
      })
    }
    img.src = imageUrl
  })
}

export default daltonizeImages
